import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentLanguage, LANGUAGES, LANGUAGE_NAMES } from '../../utils/languageUtils';
import './style.less';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { pathname, search, hash } = useLocation();

  const currentLang = getCurrentLanguage(i18n);
  const targetLang = currentLang === LANGUAGES.BG ? LANGUAGES.EN : LANGUAGES.BG;

  // The language lives in the URL path, so switching navigates to the other
  // version of the current page. The router basename is fixed per language,
  // which is why this is a full navigation rather than a client-side route change.
  const switchLanguage = () => {
    const prefix = targetLang === LANGUAGES.EN ? '/en' : '';
    const path = pathname === '/' ? '' : pathname;

    window.location.assign(`${prefix}${path}${search}${hash}` || '/');
  };

  return (
    <button
      className="language-switcher"
      onClick={switchLanguage}
      aria-label={`Switch to ${LANGUAGE_NAMES[targetLang]}`}
    >
      <span className={currentLang === LANGUAGES.BG ? 'active' : ''}>BG</span>
      <span className="separator">/</span>
      <span className={currentLang === LANGUAGES.EN ? 'active' : ''}>EN</span>
    </button>
  );
};
